import { BillingOption } from '../../../../../../../shared/utils/billing-options';
import {
  getIsRequestIdeal,
  getIsRequestPending,
} from '../../../../../../../shared/utils/get-request-status';
import {
  SubscriptionPlanModes,
  SubscriptionPlans,
} from '../../../../../../../shared/utils/subscription-plans';
import { GetAccountSubscriptionResponse } from '../../../types';
import { ModifySubscriptionSteps } from '../types';

export const billingOptions = [
  { label: 'Monthly', value: BillingOption.MONTHLY },
  { label: 'Quarterly', value: BillingOption.QUARTERLY },
  { label: 'Annually', value: BillingOption.ANNUALLY },
];

export const getHighlightMessage = (planCycle) =>
  planCycle === BillingOption.MONTHLY
    ? 'monthly_outreach_highlight_message'
    : 'yearly_outreach_highlight_message';

export const gePlanCycleBasedOnPlanType = (planCode, planMode) => {
  if (planMode === SubscriptionPlanModes.MonthlyMode) {
    return BillingOption.MONTHLY;
  }

  if (planMode === SubscriptionPlanModes.YearlyMode) {
    return BillingOption.ANNUALLY;
  }

  return BillingOption.ANNUALLY;
};

export const getDisabledLabel = (
  sendGetAccountSubscriptionResponse: GetAccountSubscriptionResponse,
) => {
  if (
    sendGetAccountSubscriptionResponse?.planMode ===
    SubscriptionPlanModes.YearlyMode
  ) {
    return 'Monthly';
  }

  return null;
};

export const getDisabledTab = (): ModifySubscriptionSteps => null;

export const isBillingAndSubscriptionPageReady = ({
  sendGetDialerSubscriptionRequestStatus,
  sendGetDialerPlansRequestStatus,
  sendGetDialerSubscriptionResponse,
  selectedPlanDetails,
}) =>
  getIsRequestPending(sendGetDialerSubscriptionRequestStatus) ||
  getIsRequestIdeal(sendGetDialerSubscriptionRequestStatus) ||
  getIsRequestPending(sendGetDialerPlansRequestStatus) ||
  getIsRequestIdeal(sendGetDialerPlansRequestStatus) ||
  !sendGetDialerSubscriptionResponse ||
  !selectedPlanDetails;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isDialerValueBasedPlanVisible = (_planCode: SubscriptionPlans, _planType, _subscriptionPlanStatus) => true;
